import { render, staticRenderFns } from "./PIThreads.vue?vue&type=template&id=8956ed4a&scoped=true"
import script from "./PIThreads.vue?vue&type=script&lang=js"
export * from "./PIThreads.vue?vue&type=script&lang=js"
import style0 from "./PIThreads.vue?vue&type=style&index=0&id=8956ed4a&prod&lang=css"
import style1 from "./PIThreads.vue?vue&type=style&index=1&id=8956ed4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8956ed4a",
  null
  
)

export default component.exports